// Test IDs for error components

export const ERROR_TEST_IDS = {
  MODAL: 'error-modal',
} as const;

